export default __webpack_public_path__ + "static/media/boldpoint.b1e9ac32.png";